import state from './moduleWalletTransactionTypeState.js'
import mutations from './moduleWalletTransactionTypeMutations.js'
import actions from './moduleWalletTransactionTypeActions.js'
import getters from './moduleWalletTransactionTypeGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
